<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-layout justify-end
                  class="mb-8">
            <v-btn color="secondary"
                   v-if="canAddGroup"
                   @click="openForm(null)"
                   data-test="addNewGroupBtn">{{ $t('buttons.add_new_site_group') }}</v-btn>
        </v-layout>
        <v-data-table :headers="headers"
                      :loading="loader"
                      disable-sort
                      :items="rawSiteGroups"
                      disable-pagination
                      hide-default-footer
                      class="elevation-1">
            <template v-for="(headerItem, i) in headers"
                      v-slot:[`header.${headerItem.value}`]="{ header }">
                <SortableHeader :header-item="header"
                                :key="i"
                                @sort="sort($event)"></SortableHeader>
            </template>

            <template v-slot:item.actions="{ item }">
                <HintingIcon class-name="mr-2"
                             :icon="ICONS.EDIT"
                             v-if="canEditGroup"
                             @click="openForm(item)"
                             :data-test="item"
                             :tooltip="$t('actions.edit')"></HintingIcon>

                <ButtonWithConfirmation :item-id="item.id"
                                        v-if="canRemoveGroup"
                                        @action-executed="emitFetch"
                                        :callback="deleteGroup"></ButtonWithConfirmation>
            </template>
        </v-data-table>

        <Pagination :pagination="pagination"
                    data-test="pagination"
                    @change-page="changePage($event)"
                    @change-amount="changeAmount($event)"></Pagination>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { ICONS } from '@/constants/icons';
import HintingIcon from '@/components/widgets/HintingIcon';
import ButtonWithConfirmation from '@/components/widgets/buttons/ButtonWithConfirmation';
import SortableHeader from '@/components/widgets/tables/SortableHeader';
import Pagination from '@/components/widgets/tables/Pagination';

export default {
    name: 'SitesGroupsTable',
    components: { SortableHeader, HintingIcon, ButtonWithConfirmation, Pagination },
    props: {
        loader: {
            type: Boolean,
            'default': false
        },
        changedPage: {
            type: [String, Number],
            required: false
        }
    },
    data: () => ({
        ICONS,
        pagination: {
            page: 1,
            amount: 20,
            amountAll: null
        },
        sortable: {
            name: 'asc',
            code: null
        }
    }),
    computed: {
        ...mapState('sites', [
            'rawSiteGroups',
            'totalSiteGroupsAmount'
        ]),
        headers () {
            return [
                {
                    text: this.$t('labels.site_groups_code'),
                    value: 'code',
                    width: '300px',
                    sortable: true
                },
                {
                    text: this.$t('labels.site_groups_name'),
                    value: 'name',
                    sortable: true
                },
                {
                    text: this.$t('incidents.table.headers.actions'),
                    value: 'actions',
                    icon: false,
                    width: '90px',
                    sortable: false
                }
            ];
        },
        canAddGroup () {
            return this.$can(this.$abilityActions.CREATE, this.$abilitySubjects.SITE_GROUP);
        },
        canEditGroup () {
            return this.$can(this.$abilityActions.UPDATE, this.$abilitySubjects.SITE_GROUP);
        },
        canRemoveGroup () {
            return this.$can(this.$abilityActions.DELETE, this.$abilitySubjects.SITE_GROUP);
        }
    },
    watch: {
        totalSiteGroupsAmount: {
            handler (val) {
                this.pagination.amountAll = val;
            },
            immediate: true
        },
        changedPage: {
            handler (val) {
                if (val !== this.pagination.page) {
                    this.pagination.page = val;
                }
            }
        }
    },
    methods: {
        changePage (event) {
            this.pagination.page = event;
            this.$emit('change-page', event);
        },
        changeAmount (event) {
            this.pagination.page = 1;
            this.pagination.amount = event;
            this.$emit('change-amount', event);
        },
        sort (event) {
            switch (this.sortable[event]) {
            case null:
                this.sortable[event] = 'desc';
                break;
            case 'asc':
                this.sortable[event] = 'desc';
                break;
            case 'desc':
                this.sortable[event] = 'asc';
                break;
            }

            this.$emit('sort', {
                name: event,
                value: this.sortable[event]
            });
        },
        emitFetch () {
            this.$emit('fetch');
        },
        openForm (item = null) {
            if (item) {
                this.$store.commit('manageSitesGroup/SET_GROUP_DATA', item);
                this.$store.commit('manageSitesGroup/SET_EDITED_GROUP_ID', item.id);
                this.$store.commit('manageSitesGroup/SET_GROUP_FORM_VISIBILITY', true);
            } else {
                this.$store.commit('manageSitesGroup/SET_GROUP_FORM_VISIBILITY', true);
            }
        },
        deleteGroup (id) {
            return this.$store.dispatch('manageSitesGroup/deleteSitesGroup', id);
        }
    }
};
</script>

<style scoped>

</style>
